import { render } from "./logoffVerificationFailModal.vue?vue&type=template&id=5f64482a&scoped=true&ts=true"
import script from "./logoffVerificationFailModal.vue?vue&type=script&lang=ts"
export * from "./logoffVerificationFailModal.vue?vue&type=script&lang=ts"

import "./logoffVerificationFailModal.vue?vue&type=style&index=0&id=5f64482a&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f64482a"]])